export enum AppearanceTheme {
    LIGHT = 1,
    DARK = 2,
    AUTO = 3
}